<template>
    <div class="services-area bg-right-shape ptb-100">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="services-content it-service-content" data-aos="fade-right">
                    <div class="content left-content">
                        <!-- <div class="icon"><img src="../../assets/img/bd_logo.jpeg" alt="image" style="height: 6vh">
                        </div> -->
                        <h2>IT-Beratung</h2>
                        <p>Sie haben eine Idee, aber wissen nicht, wie Sie diese umsetzen sollen? Gemeinsam analysieren wir Ihre Anforderungen und entwickeln eine Strategie, die zu Ihrem Budget und Ihren Zielen passt.</p>

                        <div class="feature-cards-grid">
                            <div class="feature-card-mini">
                                <i class='bx bx-search-alt'></i>
                                <span>Anforderungsanalyse</span>
                            </div>
                            <div class="feature-card-mini">
                                <i class='bx bx-chip'></i>
                                <span>Technologieberatung</span>
                            </div>
                            <div class="feature-card-mini">
                                <i class='bx bx-calendar-check'></i>
                                <span>Projektplanung</span>
                            </div>
                            <div class="feature-card-mini">
                                <i class='bx bx-calculator'></i>
                                <span>Kostenabschätzung</span>
                            </div>
                            <div class="feature-card-mini">
                                <i class='bx bx-check-shield'></i>
                                <span>Machbarkeitsprüfung</span>
                            </div>
                            <div class="feature-card-mini">
                                <i class='bx bx-bulb'></i>
                                <span>Lösungskonzepte</span>
                            </div>
                        </div>

                        <router-link to="/services/it-beratung" class="btn-benovium">
                            <i class="bx bxs-spreadsheet"></i>
                            Mehr erfahren
                        </router-link>
                    </div>
                </div>

                <div class="services-image" data-aos="fade-left">
                    <div class="image">
                        <!-- <img src="../../assets/img/services-image/service5.png" alt="image"> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ITConsultancy'
}
</script>